import { StandardEvents } from '@shopify/events';

/**
 * Shows a small, non-blocking banner suggesting the poster stand ("Soporte
 * para Pósteres y Láminas") whenever a shopper successfully adds a different
 * product to the cart, unless the stand is already in the cart. The banner
 * links to the stand's product page — it never adds anything to the cart
 * itself, since the stand comes in several colors/sizes the shopper should
 * pick themselves.
 */
if (!window.__cartCrossSellInit) {
  window.__cartCrossSellInit = true;

  /** @type {HTMLElement | null} */
  let banner = null;
  let wired = false;

  function getBanner() {
    if (!banner) banner = document.getElementById('cart-cross-sell-banner');
    return banner;
  }

  /**
   * @param {HTMLElement} bannerEl
   * @param {Array<{ product_id?: number | string }>} items
   */
  function crossSellAlreadyInCart(bannerEl, items) {
    const productId = Number(bannerEl.dataset.productId);
    return items.some((item) => Number(item.product_id) === productId);
  }

  /**
   * @param {HTMLElement} bannerEl
   */
  function wireBanner(bannerEl) {
    if (wired) return;
    wired = true;

    const dismissButton = bannerEl.querySelector('[data-cross-sell-dismiss]');
    dismissButton?.addEventListener('click', () => hideBanner(bannerEl));
  }

  /** @param {HTMLElement} bannerEl */
  function showBanner(bannerEl) {
    bannerEl.hidden = false;
    // Force layout so the transition to `.is-visible` actually animates.
    void bannerEl.offsetHeight;
    bannerEl.classList.add('is-visible');
  }

  /** @param {HTMLElement} bannerEl */
  function hideBanner(bannerEl) {
    bannerEl.classList.remove('is-visible');
    bannerEl.addEventListener('transitionend', () => (bannerEl.hidden = true), { once: true });
  }

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.action !== 'add') return;

    const bannerEl = getBanner();
    if (!bannerEl || bannerEl.classList.contains('is-visible')) return;

    wireBanner(bannerEl);

    event.promise
      ?.then(({ detail }) => {
        if (!detail || detail.didError) return;
        if (String(detail.productId) === bannerEl.dataset.productId) return;
        if (Array.isArray(detail.items) && crossSellAlreadyInCart(bannerEl, detail.items)) return;

        showBanner(bannerEl);
      })
      .catch(() => {});
  });
}
